/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import axios from 'axios';

/**
 * Domain errors (`DomainError` subclasses on the API) always respond with
 * `{ statusCode, error, message }` where `message` is a human-readable reason
 * (e.g. "That room is already booked for this time slot"). Prefer surfacing
 * that over a generic fallback so the user knows *why* an action failed.
 */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (axios.isAxiosError<{ message?: unknown }>(err)) {
    const message = err.response?.data.message;
    if (typeof message === 'string' && message.length > 0) {
      return message;
    }
  }
  return fallback;
}
